export function loadLayout(file, callback) {
    fetch(`/templates/${file}.json`)
        .then((res) => res.json())
        .then((json) => {
            // console.info(json);

            if (callback) callback(json);
        });
}

export function loadTemplate(groups, callback) {
    const tasks = groups.map((t, i) => {
        if (t.file) {
            return fetch(`/templates/${t.file}.json`)
                .then((res) => res.json())
                .catch((reason) => false);
        } else {
            return false;
        }
    });

    const _grps = [...groups];

    Promise.all(tasks)
        .then((values) => {
            values.forEach((t, i) => {
                if (t) {
                    // _grps[i].template = t; // error of read only
                    _grps[i] = {..._grps[i], template: t};
                }
            });
        })
        .then(() => {
            callback(_grps);
        });
}

export function loadTemplateFile(file, callback) {
    fetch(`/templates/${file}.json`)
        .then((res) => res.json())
        .then((json) => callback(json))
        .catch((reason) => false);
}

export function createAppContainer(id) {
    const appContainer = document.querySelectorAll(`#${id}`);
    if (appContainer.length === 0) {
        const root = document.querySelector(`div#content`);
        const appDiv = document.createElement('div');
        appDiv.id = `${id}`;

        root.appendChild(appDiv);
    }
}
